module.exports = __webpack_public_path__ + "static/04-e29c0e294cb535bc1b2cdb343cb2dffd.jpg";